function productFromFacebookData(data) {
  return {
    title: data.title,
    id: data.productID,
    description: data.description,
    imageURI: data.imageURI,
    price: data.price,
    currencyCode: data.priceCurrencyCode
  };
}
export {
  productFromFacebookData
};
